import type { InjectionKey } from 'vue'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'
import { ROUTES as PRODUCT_LIST_ROUTES } from '~/scopes/product-list/route-names'

import { ROUTES as REVIEWS_ROUTES } from '../route-names'

export const MAX_RATING = 5

export const MAX_COMMENT_LENGTH = 1200

export const TRACKING_ZONE = 'reviews'

export const REVIEWS_LIST_DEFAULT_LENGTH = 10

export const MAX_REVIEWS_DISPLAYED_IN_LIST = 7

export const scrollToTargetKey = Symbol('scrolltoTarget') as InjectionKey<
  () => void
>

export const reviewsRequestEndpoints = {
  [PRODUCT_ROUTES.MASTER_PRODUCT_PAGE]: {
    getReviews: '/reviews/v1/products/:uuid/reviews',
    getRating: '/reviews/products/:uuid/reviews-summary',
    getRatingDetailsSummary: '/reviews/products/:uuid/reviews/details-summary',
  },
  [PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE]: {
    getReviews: '/reviews/v1/products/:uuid/reviews',
    getRating: '/reviews/products/:uuid/reviews-summary',
    getRatingDetailsSummary: '/reviews/products/:uuid/reviews/details-summary',
  },
  [PRODUCT_LIST_ROUTES.PRODUCT_LIST]: {
    getReviews: '/reviews/v1/product-landings/:uuid/products/reviews',
    getRating: '/reviews/product-landings/:uuid/products/reviews-summary',
    getRatingDetailsSummary:
      '/reviews/product-landings/:uuid/products/reviews/details-summary',
  },
  [PRODUCT_LIST_ROUTES.SELLER_PRODUCT_LIST]: {
    getReviews: '/reviews/v1/sellers/:uuid/products/reviews',
  },
  [REVIEWS_ROUTES.PAGES.ALL]: {
    getRating: '/reviews/products/reviews-summary',
  },
} as const

export const reviewsConfig = {
  [PRODUCT_ROUTES.MASTER_PRODUCT_PAGE]: {
    headers: { 'BM-Page-Name': PRODUCT_ROUTES.MASTER_PRODUCT_PAGE },
    parameters: { hasAIReviewsSummary: true },
  },
  [PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE]: {
    headers: { 'BM-Page-Name': PRODUCT_ROUTES.VARIANT_PRODUCT_PAGE },
    parameters: { hasAIReviewsSummary: true },
  },
} as const
